"use client";

import React from "react";
import { Award, ShieldCheck, Shield, Flame, MessageSquare, MapPin, Phone } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = [{
  id: "rgi",
  title: "RGI registered",
  description: "Registered Gas Installer certified for safe gas boiler and heating service across Dublin.",
  icon: Award
}, {
  id: "seai",
  title: "SEAI registered installer",
  description: "Approved installer for energy-efficient heating systems and heat pump installations.",
  icon: ShieldCheck
}, {
  id: "insured",
  title: "Fully insured",
  description: "Comprehensive insurance coverage for all residential and commercial plumbing and heating work.",
  icon: Shield
}, {
  id: "expertise",
  title: "Boiler, heat pump and plumbing expertise",
  description: "Skilled work across gas boilers, heat pumps, powerflushing, and general plumbing services.",
  icon: Flame
}, {
  id: "communication",
  title: "Clear communication before work begins",
  description: "Transparent guidance, clear explanations, and upfront project details before starting any job.",
  icon: MessageSquare
}, {
  id: "coverage",
  title: "Dublin-wide service coverage",
  description: "Dependable plumbing and heating solutions delivered right across Dublin city and county.",
  icon: MapPin
}, {
  id: "contact",
  title: "Telephone and WhatsApp contact",
  description: "Direct phone and WhatsApp assistance for quick enquiries and scheduled services.",
  icon: Phone
}];
export default function WhyChooseD4PlumbingHeating() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222900" id="why-choose-d4-plumbing-heating" className="bg-background text-foreground py-20 lg:py-32 overflow-hidden" ref={ref}>
      <div className={`container mx-auto px-4 md:px-6 transition-all duration-1000 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        <div className="text-center max-w-3xl mx-auto mb-16 lg:mb-20">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-default font-bold tracking-tight mb-6 text-primary">
            Why Choose D4 Plumbing & Heating?
          </h2>
          <p className="text-lg text-muted-foreground font-default">
            Practical, professional plumbing and heating work across Dublin,
            carried out by registered engineers.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 md:gap-8">
          {features.map((feature, i) => {
          const Icon = feature.icon;
          return <div key={feature.id} data-index={i} className="bg-card border border-border/80 rounded-lg p-6 shadow-md hover:shadow-lg transition-all duration-300 flex flex-col items-start">
                <div className="p-3 rounded-lg bg-primary/10 text-primary mb-5 shrink-0">
                  <Icon className="w-6 h-6" />
                </div>
                <h3 className="text-xl font-default font-bold text-foreground mb-3">
                  {feature.title}
                </h3>
                <p className="text-muted-foreground font-default text-sm md:text-base leading-relaxed">
                  {feature.description}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}